export enum GDPR_BANNER {
    TITLE_BANNER = 'FRONT.GDPR_BANNER.TITLE_BANNER',
    TEXT_BANNER = 'FRONT.GDPR_BANNER.TEXT_BANNER',
    DECLINE = 'FRONT.GDPR_BANNER.DECLINE',
    ACCEPT = 'FRONT.GDPR_BANNER.ACCEPT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=488772058
     */
    MANAGE_OPTIONS_BODY = 'GDPR_BANNER.MANAGE_OPTIONS_BODY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489813582
     */
    STRICTLY_NECESSARY_COOKIES = 'GDPR_BANNER.STRICTLY_NECESSARY_COOKIES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489813661
     */
    ALWAYS_ACTIVE = 'GDPR_BANNER.ALWAYS_ACTIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489813961
     */
    ANALYTICS_COOKIES = 'GDPR_BANNER.ANALYTICS_COOKIES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489911875
     */
    PRIVACY_PREFERENCES = 'GDPR_BANNER.PRIVACY_PREFERENCES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489917256
     */
    BANNER_TITLE = 'GDPR_BANNER.BANNER_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=489918297
     */
    BANNER_BODY = 'GDPR_BANNER.BANNER_BODY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=29475684
     */
    ACCEPT_ALL = 'GDPR_BANNER.ACCEPT_ALL_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=490099374
     */
    MANAGE_OPTIONS = 'GDPR_BANNER.MANAGE_OPTIONS_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=490099397
     */
    NON_ESSENTIAL_COOKIES = 'GDPR_BANNER.REFUSE_NON_ESSENTIAL_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=490322369
     */
    I_UNDERSTAND = 'GDPR_BANNER.I_UNDERSTAND_BUTTON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=491661789
     */
    ANALYTICS_COOKIES_HELPER = 'GDPR_BANNER.ANALYTICS_COOKIES_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=491661633
     */
    STRICTLY_NECESSARY_COOKIES_HELPER = 'GDPR_BANNER.STRICTLY_NECESSARY_COOKIES_HELPER',
}
